import { UsersClient } from '@Clients/UserClient';

export const getBaseUser = async (userId: string, email: string) => {
  const simpleUser = await UsersClient.getUserById(userId);
  if (!simpleUser) {
    const newUser = await UsersClient.createUser({
      id: userId,
      email: email,
    });

    return newUser;
  }

  return simpleUser;
};
